<div
  *ngIf="!!formField && !!choicesMap"
  class="checkbox-choices"
>
  <mat-checkbox
    *ngFor="let choice of choicesMap | keyvalue"
    [checked]="isChoiceChecked(choice.value)"
    (click)="toggleChoice(choice.value)"
  >
    {{ choice.key }}
  </mat-checkbox>
</div>
